import React, { useRef, useState } from "react";
import {
  TextField,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Stack,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import { Add } from "@mui/icons-material";

interface MinuteRecurrenceGeneratorTypes {
  selectedMinuteRecurrenceType: number;
  setSelectedMinuteRecurrenceType: React.Dispatch<React.SetStateAction<number>>;
  typeTwoMinuteValue: Record<number, boolean>;
  setTypeTwoMinuteValue: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
}

const MinuteRecurrenceGenerator = (props: MinuteRecurrenceGeneratorTypes) => {
  const {
    selectedMinuteRecurrenceType,
    setSelectedMinuteRecurrenceType,
    typeTwoMinuteValue,
    setTypeTwoMinuteValue,
  } = props;
  const translations = useTranslations();
  const [error, setError] = useState<boolean>(false);
  const inpRef = useRef<HTMLInputElement | null>(null);

  const handleSubmit = (
    target: EventTarget & (HTMLInputElement | HTMLTextAreaElement)
  ) => {
    if (target.value) {
      if (Number(target.value) <= 59 && Number(target.value) >= 0) {
        setTypeTwoMinuteValue((_) => ({
          ..._,
          [Number(target.value)]: true,
        }));
        target.value = "";
        target.focus();
      } else {
        setError(true);
      }
    }
  };
  // useEffect(() => {
  // return () => {
  // setTypeTwoMinuteValue({});
  // setSelectedMinuteRecurrenceType(0);
  // };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  return (
    <Stack spacing={2}>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={selectedMinuteRecurrenceType}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            if (Number(event.target.value) === 0) {
              setTypeTwoMinuteValue({});
            }
            setSelectedMinuteRecurrenceType(Number(event.target.value));
          }}
        >
          <FormControlLabel
            value={0}
            control={<Radio />}
            label={getTranslation(
              translations,
              "pm.propertyeditor.specificproperties.repetition_details.cycle.label.minutely.none"
            )}
          />
          <FormControlLabel
            value={3}
            control={<Radio />}
            label={getTranslation(
              translations,
              "pm.propertyeditor.specificproperties.repetition_details.cycle.label.minutely.every_minute_range"
            )}
          />
        </RadioGroup>
      </FormControl>
      {Boolean(Object.keys(typeTwoMinuteValue).length) && (
        <Typography variant="caption">
         {getTranslation(translations, "generic.selectedminutes")} {Object.keys(typeTwoMinuteValue).join(", ")}
        </Typography>
      )}
      <form>
        {selectedMinuteRecurrenceType === 3 && (
          <TextField
            size="small"
            type="number"
            inputRef={inpRef}
            error={error}
            helperText={error && getTranslation(translations, "generic.valueoutofrange")}
            defaultValue={0}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              sx: { pr: 0 },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={(e) => {
                      e.preventDefault();
                      setError(false);
                      inpRef.current && handleSubmit(inpRef.current);
                    }}
                    type="submit"
                  >
                    <Add />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            inputProps={{ max: 59, min: 0 }}
            label={getTranslation(translations, "system.pm.choose_minutes.label")}
            // onBlur={(e) => handleSubmit(e.target)}
            // onKeyDown={(e) => {
            //   e.key === "Enter" &&
            //     handleSubmit(
            //       e.target as EventTarget &
            //         (HTMLInputElement | HTMLTextAreaElement)
            //     );
            // }}
          />
        )}
      </form>
    </Stack>
  );
};

export default MinuteRecurrenceGenerator;
